@use "../../../assets/styles/abstracts/variables" as v;
@use "../../../assets/styles/abstracts/mixins/typography" as t;

.itemNotFound {
  color: v.$gray-light-color;
  @include t.text(14px, 22px, "normal");
  text-align: center;
}

.list {
  padding: 4px 8px;
  position: absolute;
  top: 48px;
  left: 50%;
  transform: translateX(-50%);
  width: 240px;
  height: auto;
  max-height: 200px;
  overflow-y: auto;
  border-radius: 6px;
  border: 1px solid v.$gray-border-color;
  background: v.$navy-color;
  box-shadow: v.$shadow-dropdown;
  z-index: 4;
}

.listChineseBrothers {
  background: v.$chinese-brothers-input-bg;
  border-color: v.$chinese-brothers-input-border;
}

.item {
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 8px;
  padding: 8px;
  border-radius: 6px;
  color: v.$white-color;
  @include t.text(14px, 22px, "normal");

  &:hover {
    background-color: v.$gray-border-color;
  }
}

.listChineseBrothers .item:hover {
  background-color: v.$chinese-brothers-input-border;
}

.itemFlag {
  width: 18px;
  height: 12px;
}
